webpackJsonp([3],{

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tracking03_vue__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a7f9f0f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_tracking03_vue__ = __webpack_require__(807);
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tracking03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a7f9f0f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_tracking03_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_selectors_NewAreaSelector_vue__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_selectors_StaticSelector_vue__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_selectors_ElStaticSelector_vue__ = __webpack_require__(804);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NewAreaSelector: __WEBPACK_IMPORTED_MODULE_0__components_selectors_NewAreaSelector_vue__["a" /* default */],
    StaticSelector: __WEBPACK_IMPORTED_MODULE_1__components_selectors_StaticSelector_vue__["a" /* default */],
    ElStaticSelector: __WEBPACK_IMPORTED_MODULE_2__components_selectors_ElStaticSelector_vue__["a" /* default */]
  },
  name: 'tracking03',
  data: function data() {
    var _this = this;

    var validateZipCode = function validateZipCode(rule, value, callback) {
      if (_this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      value = _this.calculate[rule.field];
      if (value !== 0 && !value) {
        var errorMsg = '该项为必填项';
        if (rule.field === 'zipCode') {
          errorMsg = '请输入邮编';
        }
        return callback(new Error(errorMsg));
      }
      if (value.toString().length > 10) {
        return callback(new Error('输入的邮编过长'));
      }
      var xsd = value.toString().indexOf('.');
      if (xsd > 0) {
        return callback(new Error('请输入数字'));
      }
      var reg = /^[0-9a-zA-Z\s+]+$/;
      // value = value - 0;
      if (!value.match(reg)) {
        return callback(new Error('只可以输入字母数字空格'));
      }
      return callback();
    };
    var valiWeightNumber = function valiWeightNumber(rule, value, callback) {
      if (_this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      value = _this.calculate[rule.field];
      if (value !== 0 && !value) {
        var errorMsg = '该项为必填项';
        return callback(new Error(errorMsg));
      }
      value = value - 0;
      if (isNaN(value)) {
        return callback(new Error('请输入数字'));
      }
      if (typeof value === 'number') {
        if (value < 0) {
          return callback(new Error('最小可输入0'));
        }
        if (value > 99999.9999) {
          return callback(new Error('最大可输入5位整数,5位小数'));
        }
        var xsd = value.toString().split('.');
        if (xsd.length > 1) {
          if (xsd[1].length > 4) {
            return callback(new Error('最长可以输入四位小数'));
          }
        }
        return callback();
      } else {
        return callback(new Error('请输入数字'));
      }
    };
    var validateNumber = function validateNumber(rule, value, callback) {
      if (_this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      value = _this.calculate[rule.field];
      if (value !== 0 && !value) {
        var errorMsg = '该项为必填项';
        if (rule.field === 'zipCode') {
          errorMsg = '请输入邮编';
        }
        return callback(new Error(errorMsg));
      }
      value = value - 0;
      if (isNaN(value)) {
        return callback(new Error('请输入数字'));
      }
      if (typeof value === 'number') {
        if (value < 0) {
          return callback(new Error('最小可输入0'));
        }
        if (value > 9999.9999) {
          return callback(new Error('最大可输入4位整数,4位小数'));
        }
        var xsd = value.toString().split('.');
        if (xsd.length > 1) {
          if (xsd[1].length > 4) {
            return callback(new Error('最长可以输入四位小数'));
          }
        }
        return callback();
      } else {
        return callback(new Error('请输入数字'));
      }
    };
    var validateNull = function validateNull(rule, value, callback) {
      if (_this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      value = _this.calculate[rule.field];
      if (value !== 0 && !value) {
        var errorMsg = '该项为必填项';
        if (rule.field === 'destination') {
          errorMsg = '请选择目的国';
        }
        return callback(new Error(errorMsg));
      }
      return callback();
    };
    //校验部分
    var validateIsNumber = function validateIsNumber(rule, value, callback) {
      //仅包含数字和小数点才接着做后续校验
      if (/^[0-9.]*$/.test(value)) {
        if (/^[0]*$/.test(value) || /^[0]*[.][0]*$/.test(value)) {
          _this.flags[rule.field] = false;
          return callback(new Error(_this.$t('tracking.tracking03.spkPriceCalculate.alert.notZero')));
        } else if (!/^[0-9]*$/.test(value) && !/^.*[.]{1}.{1,4}$/.test(value)) {
          //若不包含小数点则直接下一级验证，若含小数点，验证小数位数
          _this.flags[rule.field] = false;
          return callback(new Error(_this.$t('tracking.tracking03.spkPriceCalculate.alert.decimalRange0to4')));
        } else if (/^[0]{1}[.][0-9]*$/.test(value) || /^[1-9]{1}[0-9]*[.][0-9]*$/.test(value) || /^[1-9]{1}[0-9]*$/.test(value)) {
          //验证是否是符合规则的有效小数或整数
          _this.flags[rule.field] = true;
          return callback();
        }
      }
      _this.flags[rule.field] = false;
      return callback(new Error(_this.$t('tracking.tracking03.spkPriceCalculate.alert.invalid')));
    };

    var validateNotNull = function validateNotNull(rule, value, callback) {
      // debugger
      if (_this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      //直接用value会是undefined，应该是iview的bug，直接用iview自带验证也有很多bug
      value = _this.calculate[rule.field];
      //去除输入空格的空格再校验，若下拉框传来的值是object的，不用去空格
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? !value : value.trim() === '') {
        _this.flags[rule.field] = false;
        return callback(new Error(_this.$t('tracking.tracking03.spkPriceCalculate.alert.notNull')));
      } else {
        //嵌套实现多重验证，直接往原生的验证数组里添加无法实现，不知道为啥
        if (rule.type === 'number') {
          return validateIsNumber(rule, value.trim(), callback);
        }
        _this.flags[rule.field] = true;
        //必须有这个，不然会加载一个转圈的gif，会挡到输入值
        return callback();
      }
      return callback();
    };
    return {
      orderTimeOptions: {
        disabledDate: function disabledDate(date) {
          var befor = date && date.valueOf() < Date.now() - 86400000;
          var after = date.valueOf() > Date.now() + 1000 * 60 * 60 * 24 * 3;
          return befor || after;
        }
      },
      requestLoading: false,
      arrivalsPriceAreaCodeSelector: {
        emptyText: '',
        sellectorUser: 0
      },
      calcuNullShow: false,
      datagridShow: false,
      priceCalcMouseOver: false,
      dlpriceCalcMouseOver: false,
      hkpriceCalcMouseOver: false,
      //控制按钮点击的flag
      flags: {
        departure: '',
        destination: '',
        weight: '',
        length: '',
        width: '',
        height: '',
        charged: '',
        //用于重置数据时跳过验证
        reset: false
      },
      isMC: false,
      gridData: [],
      departure2: null,
      calculate: {
        departureEn: '',
        departure: 'CN',
        destination: null,
        destinationProvince: '',
        orderTime: new Date(),
        charged: '1',
        incoterm: '',
        product: '',
        weight: '',
        length: '',
        width: '',
        height: '',
        productInnerId: '',
        project: '',
        zipCode: '',
        addressValidation: null,
        letter: null,
        channelCode: []
      },
      charged: [{
        key: this.$t('tracking.tracking03.list.yes'),
        value: '0'
      }, {
        key: this.$t('tracking.tracking03.list.no'),
        value: '1'
      }],
      spkPriceCalculatorShow: false,
      showSpeedPAK: true,
      showSpeedPAKcn: true,
      showSpeedPAKhk: false,
      showSpeedFreight: false,
      showSpeedFreightAsia: false,
      showCf: false,
      showMc: false,
      trackingProductsCn: "https://static.orangeconnex.com" + '/website/file/tracking03_pic.jpg?1',
      trackingProductsEn: "https://static.orangeconnex.com" + '/website/file/tracking03_EN.jpg?2',
      hkPriceImgCn: "https://static-website.orangeconnex.com" + '/file/eBayHKCN.jpg?1',
      hkPriceImgEn: "https://static-website.orangeconnex.com" + '/file/eBayHKEN.jpg?2',
      spfImgCn: "https://static.orangeconnex.com" + '/website/file/cfPrice_pic.jpg?1',
      spfImgEn: "https://static.orangeconnex.com" + '/website/file/cfPrice_EN.jpg?2',
      spfAsiaImgCn: "https://static.orangeconnex.com" + '/website/file/spfPricePic_ZH.jpg?1',
      spfAsiaImgEn: "https://static.orangeconnex.com" + '/website/file/spfPricePic_EN.jpg?2',
      mcImgCn: "https://static.orangeconnex.com" + '/website/file/mcPricePic_ZH.jpg?2',
      mcImgEn: "https://static.orangeconnex.com" + '/website/file/mcPricePic_EN.jpg?2',
      //表单各输入条件的校验规则
      validateRules: {
        departure: [{ validator: validateNotNull, trigger: 'change', required: true }],
        destination: [{ validator: validateNotNull, trigger: 'change', required: true }],
        project: [{ validator: validateNotNull, trigger: 'change', required: true }],
        product: [{ validator: validateNotNull, trigger: 'change', required: true }],
        weight: [{ validator: validateNotNull, trigger: 'blur', required: true, type: 'number' }],
        length: [{ validator: validateNotNull, trigger: 'blur', required: true, type: 'number' }],
        width: [{ validator: validateNotNull, trigger: 'blur', required: true, type: 'number' }],
        height: [{ validator: validateNotNull, trigger: 'blur', required: true, type: 'number' }],
        zipCode: [{ validator: validateNotNull, trigger: 'blur', required: true, type: 'number' }],
        charged: [{ validator: validateNotNull, trigger: 'change', required: true }]
      },
      validateRules2: {
        departure: [{ validator: validateNull, trigger: 'change', required: true }],
        destination: [{ validator: validateNull, trigger: 'change', required: true }],
        weight: [{ validator: valiWeightNumber, trigger: 'change', required: true, type: 'number' }],
        length: [{ validator: validateNumber, trigger: 'change', required: true, type: 'number' }],
        width: [{ validator: validateNumber, trigger: 'change', required: true, type: 'number' }],
        height: [{ validator: validateNumber, trigger: 'change', required: true, type: 'number' }],
        zipCode: [{ validator: validateZipCode, trigger: 'change', required: true, type: 'number' }],
        charged: [{ validator: validateNull, trigger: 'change', required: true }]
      }
    };
  },

  computed: {
    tracking03: function tracking03() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.trackingProductsCn + new Date().getTime();
      } else if (this.$i18n.locale === 'en-US') {
        return this.trackingProductsEn + new Date().getTime();
      }
    },
    hkPriceImg: function hkPriceImg() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.hkPriceImgCn + new Date().getTime();
      } else if (this.$i18n.locale === 'en-US') {
        return this.hkPriceImgEn + new Date().getTime();
      }
    },
    spfImg: function spfImg() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.spfImgCn + new Date().getTime();
      } else if (this.$i18n.locale === 'en-US') {
        return this.spfImgEn + new Date().getTime();
      }
    },
    spfAsiaImg: function spfAsiaImg() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.spfAsiaImgCn + new Date().getTime();
      } else if (this.$i18n.locale === 'en-US') {
        return this.spfAsiaImgEn + new Date().getTime();
      }
    },
    mcImg: function mcImg() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.mcImgCn + new Date().getTime();
      } else if (this.$i18n.locale === 'en-US') {
        return this.mcImgEn + new Date().getTime();
      }
    },

    //校验是否已填写所有必填项
    calculateControl: function calculateControl() {
      return this.calculate.destination && this.calculate.weight && this.calculate.length && this.calculate.width && this.calculate.height && this.calculate.departure && this.calculate.charged;
    },
    departureList: function departureList() {
      var options = [{
        key: this.$t('tracking.tracking03.list.cn'),
        value: 'CN'
      }, {
        key: this.$t('tracking.tracking03.list.hk'),
        value: 'HK'
      }];
      return options;
    },
    language222: function language222() {
      return this.$i18n.locale;
    }
  },
  watch: {
    '$i18n.locale': {
      handler: function handler() {
        // this.clickReset()
        // this.loaddeparture()
        this.$refs.arrivalsPriceAreaCodeSelector2.loadData();
        this.datagridShow = false;
      },
      deep: true
    }

  },
  methods: {
    toSpeedPAK: function toSpeedPAK() {
      this.showSpeedPAK = true;
      this.spkPriceCalculatorShow = false;
      this.showSpeedPAKcn = true;
      this.showSpeedPAKhk = false;
      this.showSpeedFreight = false;
      this.showSpeedFreightAsia = false;
      this.showCf = false;
      this.showMc = false;
    },
    toCf: function toCf() {
      this.showSpeedPAK = false;
      this.showCf = true;
    },
    toSpeedFreight: function toSpeedFreight() {
      this.showSpeedPAK = false;
      this.showSpeedFreight = true;
      this.showSpeedFreightAsia = false;
      this.showMc = false;
    },
    toSpeedFreightAsia: function toSpeedFreightAsia() {
      this.showSpeedPAK = false;
      this.showSpeedFreight = false;
      this.showSpeedFreightAsia = true;
      this.showMc = false;
    },
    toMc: function toMc() {
      this.showSpeedPAK = false;
      this.showSpeedFreight = false;
      this.showSpeedFreightAsia = false;
      this.showMc = true;
    },
    dlPriceCardDownload: function dlPriceCardDownload() {
      this.spkPriceCalculatorShow = false;
      this.showSpeedPAKhk = false;
      this.showSpeedPAKcn = true;
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open("https://static.orangeconnex.com" + '/website/file/SpeedPAK_CHN_CN.xlsx?1');
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open("https://static.orangeconnex.com" + '/website/file/SpeedPAK_CHN_EN.xlsx?2');
      }
    },
    mcPriceCardDownload: function mcPriceCardDownload() {
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open("https://static.orangeconnex.com" + '/website/file/MultiChannel_CHN_CN.xlsx?1');
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open("https://static.orangeconnex.com" + '/website/file/MultiChannel_CHN_EN.xlsx?2');
      }
    },
    hkPriceCardDownload: function hkPriceCardDownload() {
      this.spkPriceCalculatorShow = false;
      this.showSpeedPAKhk = true;
      this.showSpeedPAKcn = false;
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open("https://static.orangeconnex.com" + '/website/file/SpeedPAK_HKG_CN.xlsx?1');
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open("https://static.orangeconnex.com" + '/website/file/SpeedPAK_HKG_EN.xlsx?2');
      }
    },
    dlMiniPriceCardDownload: function dlMiniPriceCardDownload() {
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open("https://static.orangeconnex.com" + '/website/file/SPK_Mini_CHN_CN.xlsx?1');
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open("https://static.orangeconnex.com" + '/website/file/SPK_Mini_CHN_EN.xlsx?2');
      }
    },

    //spf中国价卡
    spfPriceCardDownload: function spfPriceCardDownload() {
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open("https://static.orangeconnex.com" + '/website/file/SpeedFreight_CHN_CN.xlsx?1');
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open("https://static.orangeconnex.com" + '/website/file/SpeedFreight_CHN_EN.xlsx?2');
      }
    },

    //spf东南亚价卡
    spfAsiaPriceCardDownload: function spfAsiaPriceCardDownload() {
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open("https://static.orangeconnex.com" + '/website/file/SpeedFreight_SEA_CN.xlsx?1');
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open("https://static.orangeconnex.com" + '/website/file/SpeedFreight_SEA_EN.xlsx?2');
      }
    },
    spkPriceCalculator: function spkPriceCalculator() {
      this.spkPriceCalculatorShow = !this.spkPriceCalculatorShow;
    },

    addSelectDestinationChange: function addSelectDestinationChange(data) {
      if (data && data.length > 0) {
        this.calculate.destination = data[0];
      } else {
        this.calculate.destination = '';
      }

      if (data && data.length > 1) {
        this.calculate.destinationProvince = data[1];
      } else {
        this.calculate.destinationProvince = '';
      }
      // this.initInnerProduct()
    },
    clickCalculate: function clickCalculate() {
      var _this2 = this;

      this.$refs.validateRule.validate(function (valid) {
        //表单校验
        if (!valid) {
          return;
        }
        _this2.calcuNullShow = false;
        _this2.requestLoading = true;
        var volumeWeight = ''; //体积重
        var chareType = _this2.$t('tracking.tracking03.spkPriceCalculate.gridData.chareType_actual'); //计费方式  实重
        var length = _this2.calculate.length;
        var width = _this2.calculate.width;
        var height = _this2.calculate.height;
        var weightTemp = _this2.calculate.weight;
        //提取目的国下拉框组件的值拼接字面值
        /*let areaList = this.$refs.initSelectCascaderData2Ref.areaList;
        let currArea = this.$refs.initSelectCascaderData2Ref.currArea;
        let label = '';
        for (let area of areaList) {
          if (area.value === currArea[0]) {
            label = area.label;
          }
          if (area.children) {
            for (let child of area.children) {
              if (child.value === currArea[1]) {
                label = label + '-' + child.label;
              }
            }
          }
        }*/
        // let departure = this.calculate.departure === 'CN' ? this.$t('tracking.tracking03.spkPriceCalculate.list.cn') : this.$t('tracking.tracking03.spkPriceCalculate.list.hk');
        //计算逻辑步骤1
        if (length >= 40 || width >= 40 || height >= 40) {
          //计算逻辑步骤2，计抛条件
          var volume = length * width * height;
          volumeWeight = Math.round(volume / 6 * 10000) / 10000;
          if (volume / 7.8 > weightTemp) {
            weightTemp = volume / 6 - weightTemp * 0.3;
            chareType = _this2.$t('tracking.tracking03.spkPriceCalculate.gridData.chareType_weighting'); //计抛重
          }
        }
        //墨西哥路向特殊处理
        if (_this2.calculate.destination === 'MX') {
          var _volume = length * width * height / 6;
          if (_volume > weightTemp) {
            chareType = _this2.$t('tracking.tracking03.spkPriceCalculate.gridData.chareType_weighting'); //计抛重
          }
          weightTemp = _volume > weightTemp ? _volume : weightTemp;
          volumeWeight = Math.round(_volume * 10000) / 10000;
        }
        //重量最多保留四位小数
        weightTemp = Math.round(weightTemp * 10000) / 10000;
        var orderTimeTmp = _this2.calculate.orderTime ? new Date(_this2.calculate.orderTime).getTime() : null;
        //计算逻辑步骤3,组装请求参数并请求接口
        var params = {
          // productId: this.calculate.product,
          // batteryType: this.calculate.charged,
          // batteryType: 2, //全部
          incoterm: 0,
          departure: _this2.calculate.departure,
          destination: _this2.calculate.destination,
          destinationProvince: _this2.calculate.destinationProvince,
          orderTime: orderTimeTmp,
          packageWeight: weightTemp,
          packageWeightUnit: 0,
          // productInnerId: this.calculate.productInnerId,
          projectCode: 'eBay',
          zipCode: _this2.calculate.zipCode,
          letter: _this2.calculate.letter,
          addressValidation: _this2.calculate.addressValidation,
          channelCode: _this2.calculate.channelCode,
          language: _this2.$i18n.locale
        };
        _this2.datagridShow = false;
        _this2.gridData = [];
        // http.mergePostAndPut(process.env.BASE_API + '/aquarius-trace/price-estimate/v2/estimate', params).then((res) => {
        _this2.$store.dispatch("priceEstimateCalculate", params).then(function (res) {
          if (res.success) {
            if (res.priceEstimateCalculateResult.errorCode === '5001') {
              _this2.calcuNullShow = true;
            } else {
              // this.gridData[0].departure = departure;
              // this.gridData[0].destination = label;
              // this.gridData[0].weight = weightTemp+' g';
              // let history = res.result.history;
              // let current = res.result.current;
              // //价格四舍五入保留两位小数
              // this.gridData[0].totalCost = history.currency === 'CNY' ? '￥ ' + Math.round(history.freight * 100) / 100 : history.currency + ' ' + Math.round(history.freight * 100) / 100;
              // this.gridData[1].totalCost = current.currency === 'CNY' ? '￥ ' + Math.round(current.freight * 100) / 100 : current.currency + ' ' + Math.round(current.freight * 100) / 100;
              _this2.gridData = res.priceEstimateCalculateResult.result.zero;
              if (_this2.gridData.length > 0) {
                _this2.datagridShow = true;
              }
              for (var i = 0; i < _this2.gridData.length; i++) {
                _this2.gridData[i].calWeight130 = Math.round(_this2.calculate.weight * 1.3 * 10000) / 10000;
                // 取输入框长宽高，如有单边大于等于40，则计入体积重公式得出体积重
                _this2.gridData[i].volumeWeight = volumeWeight === '' ? volumeWeight : volumeWeight + ' g';
                _this2.gridData[i].chargeType = chareType;
                if (_this2.gridData[i].flowRemark === '轻小件') {
                  _this2.gridData[i].flowRemarkEn = 'lite';
                } else {
                  _this2.gridData[i].flowRemarkEn = _this2.gridData[i].flowRemark;
                }
              }
            }
          } else {
            /*this.$Message.error({
              content: res.errorMsg,
              type: 'error',
              duration: 3,
              closable: true
            });*/
          }
          _this2.requestLoading = false;
        });
      });
    },
    clickReset: function clickReset() {
      var _this3 = this;

      this.flags.reset = true;
      this.initData();
      //重置目的国选择组件
      /*this.$refs.initSelectCascaderData2Ref.currArea = [];
      this.$refs.initSelectCascaderData2Ref.currCit = [];
      this.$refs.initSelectCascaderData2Ref.currCou = [];*/
      //调用表单验证配合reset的flag来清除之前的验证留下来的错误提示
      this.$refs.validateRule.validate(function () {});
      this.$nextTick(function () {
        _this3.flags.reset = false;
      });
      /*setTimeout(() => {
        this.flags.reset = false;
      }, 200);*/
    },

    //初始化各条件的默认数据
    initData: function initData() {
      var _this4 = this;

      this.calculate.departure = 'CN';
      this.calculate.product = '0';
      this.calculate.destination = null;
      this.calculate.orderTime = new Date();
      this.calculate.charged = 1;
      this.calculate.incoterm = 0;
      this.calculate.weight = '';
      this.calculate.productInnerId = '';
      this.calculate.length = '';
      this.calculate.width = '';
      this.calculate.height = '';
      this.$nextTick(function () {
        _this4.calculate.project = 'eBay';
      });
      this.flags.departure = true;
      this.flags.destination = false;
      this.flags.weight = false;
      this.flags.product = true;
      this.flags.length = true;
      this.flags.width = true;
      this.flags.height = true;
      this.flags.project = this.flags.reset;
    },
    mouseOver: function mouseOver() {
      this.priceCalcMouseOver = true;
    },
    mouseLeave: function mouseLeave() {
      this.priceCalcMouseOver = false;
    },
    dlmouseOver: function dlmouseOver() {
      this.dlpriceCalcMouseOver = true;
    },
    dlmouseLeave: function dlmouseLeave() {
      this.dlpriceCalcMouseOver = false;
    },
    hkmouseOver: function hkmouseOver() {
      this.hkpriceCalcMouseOver = true;
    },
    hkmouseLeave: function hkmouseLeave() {
      this.hkpriceCalcMouseOver = false;
    },
    clickScroll: function clickScroll() {
      document.getElementById('clickShow').scrollIntoView();
    }
  }
});

/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAreaSelector_vue__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e549542c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewAreaSelector_vue__ = __webpack_require__(800);
function injectStyle (ssrContext) {
  __webpack_require__(796)
}
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e549542c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAreaSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e549542c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewAreaSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(797);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(34)("490fadc5", content, true);

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".ivu-col-span-13[data-v-e549542c]{width:45.3%}.ivu-col-span-17[data-v-e549542c]{width:99%}.ivu-col-span-10[data-v-e549542c]{width:53.6%}.ivu-col-span-5[data-v-e549542c]{width:26.8%}", ""]);

// exports


/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__areaUtil__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_http__ = __webpack_require__(96);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//const areaLinkageArr = util.levelArr
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewAreaSelector',
  data: function data() {
    return {
      currArea: [],
      currCit: [],
      currCou: [],
      areaList: [],
      cityList: [],
      counList: [],
      defaultPlaceholder: ['国家-省/州', '市', '县/区', '乡/镇/街'],
      defaultNotFoundText: ['无匹配', '无匹配市', '无匹配县/区', '无匹配乡/镇/街'],
      echoShow: false
    };
  },

  props: {
    gutter: {
      type: [String, Number],
      default: 5
    },
    //要和util中一致
    level: {
      type: [String, Number],
      default: 2,
      validator: function validator(val) {
        return __WEBPACK_IMPORTED_MODULE_0__areaUtil__["a" /* default */].oneOf(parseInt(val, 10), __WEBPACK_IMPORTED_MODULE_0__areaUtil__["a" /* default */].levelArr);
      }
    },
    value: {
      type: Array
    },
    searchable: {
      type: Boolean,
      default: false
    },
    dataType: {
      type: String,
      default: 'all',
      validator: function validator(val) {
        return __WEBPACK_IMPORTED_MODULE_0__areaUtil__["a" /* default */].oneOf(val, ['all', 'code', 'name']);
      }
    },
    placeholder: {
      type: [Array, String],
      default: function _default() {
        return this.defaultPlaceholder;
      }
    },
    notFoundText: {
      type: [String, Array],
      default: function _default() {
        return this.defaultNotFoundText;
      }
    },
    disabled: {
      type: [Boolean, Array, Number],
      default: false
    },
    autoLoad: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    gutterNum: function gutterNum() {
      if (typeof this.gutter === 'number') {
        return this.gutter;
      } else {
        return parseInt(this.gutter, 10);
      }
    },
    showLevel: function showLevel() {
      return parseInt(this.level, 10);
    },
    firstSpan: function firstSpan() {
      if (this.showLevel === 0) {
        return 17;
      }
      return 13;
    },
    span: function span() {
      if (__WEBPACK_IMPORTED_MODULE_0__areaUtil__["a" /* default */].oneOf(this.showLevel, __WEBPACK_IMPORTED_MODULE_0__areaUtil__["a" /* default */].levelArr)) {
        return 10 / this.showLevel;
      }
    },
    isChange: function isChange() {
      return true;
    }
  },
  watch: {
    autoLoad: function autoLoad(val) {
      if (val) {
        this.dataInit();
      }
    },
    currArea: function currArea(area) {
      if (area) {
        this.updateNextSelector('cityList', area, 0);
      }
    },
    currCit: function currCit(city) {
      if (city) {
        this.updateNextSelector('counList', city, 1);
      }
    },
    currCou: function currCou(coun) {
      if (coun) {
        this.updateNextSelector('streList', coun, 2);
      }
    },

    //      currStr (str) {
    //        this.streIndex = util.getIndex(this.streList, str)
    //        if (str) {
    //          this.returnRes(3)
    //        }
    //      }
    value: function value(val) {
      //        this.echoShow = true
      if (Array.isArray(val)) {
        if (val.length === 0) {
          this.currArea = [];
        } else if (val.length === 1) {
          this.currArea = [val[0]];
        } else {
          this.currArea = [val[0], val[1]];
        }
      }
    }
  },
  methods: {
    //初始化
    dataInit: function dataInit() {
      var _this = this;

      if (this.autoLoad) {
        var version = localStorage.getItem('districtsVersionNo2') === null ? '' : localStorage.getItem('districtsVersionNo2');
        if (localStorage.getItem('all2')) {
          var all2 = JSON.parse(localStorage.getItem('all2'));
          if (all2 && all2.length > 0) {
            all2.forEach(function (item) {
              if (item.value !== 'CN' && item.value !== 'HK' && item.value !== 'TW' && item.value !== 'MO') {
                _this.areaList.push(item);
              }
            });
          }
        } else {
          this.$store.dispatch('districtsTree', { version: version }).then(function () {
            // this.areaList = JSON.parse(localStorage.getItem('all2'))
            if (!JSON.parse(localStorage.getItem('all2'))) {
              _this.areaList = [];
            } else {
              var _all = JSON.parse(localStorage.getItem('all2'));
              if (_all && _all.length > 0) {
                _all.forEach(function (item) {
                  if (item.value !== 'CN' && item.value !== 'HK' && item.value !== 'TW' && item.value !== 'MO') {
                    _this.areaList.push(item);
                  }
                });
              }
            }
          });
        }
      }
    },

    //触发下一个节点
    updateNextSelector: function updateNextSelector(nextList, next, level) {
      if (level <= this.showLevel) {
        //区别是选的第一个
        if (next.length === 0) {
          this[nextList] = [];
          if (level === 0) {
            this.currCit = [];
          } else if (level === 1) {
            this.currCou = [];
          }
        } else if (next.length > 1 && level === 0) {
          this.loadData(nextList, next[1], level);
        } else if (next.length === 1 && level !== 0) {
          this.loadData(nextList, next[0], level);
        }
        this.returnResArr(level);
      }
    },
    loadData: function loadData(nextList, districtCode, level) {
      var _this2 = this;

      this.$store.dispatch("districtsTreeSubset", { districtCode: districtCode }).then(function (data) {
        if (!data && !data.districtTreeSubset) {
          _this2[nextList] = data.districtTreeSubset;
          _this2.$nextTick(function () {
            if (Array.isArray(_this2.value) && _this2.value.length > 0) {
              if (level === 0) {
                if (_this2.value[2]) {
                  _this2.currCit = [_this2.value[2]];
                }
              } else if (level === 1) {
                if (_this2.value[3]) {
                  _this2.currCou = [_this2.value[3]];
                }
              }
            } else {
              if (level === 0) {
                _this2.currCit = [];
              } else if (level === 1) {
                _this2.currCou = [];
              }
            }
          });
        }
      });
    },

    //返回到父组件的值
    returnResArr: function returnResArr(level) {
      var res = [];
      if (level !== undefined) {
        this.currArea.forEach(function (area) {
          if (area) {
            res.push(area);
          }
        });
        if (level === 1) {
          if (this.currCit.length === 1) {
            res.push(this.currCit[0]);
          }
        } else if (level === 2) {
          if (this.currCit.length === 1) {
            res.push(this.currCit[0]);
          }
          if (this.currCou.length === 1) {
            res.push(this.currCou[0]);
          }
        }
      }
      //        if (!this.echoShow) {
      //          this.$emit('input', res)
      //        }
      this.$emit('on-change', res);
    },
    show: function show(level) {
      return level <= this.showLevel;
    },
    handleInput: function handleInput() {
      //TODO 暂时不做功能
    },
    hasChange: function hasChange() {
      //TODO 单个选择触发
    },
    phHandled: function phHandled(level) {
      if (typeof this.placeholder === 'string' && this.placeholder !== '') {
        return this.placeholder;
      } else {
        if (this.placeholder && this.placeholder[level]) {
          return this.placeholder[level];
        } else {
          return this.defaultPlaceholder[level];
        }
      }
    },
    ndsHandled: function ndsHandled(index) {
      if (typeof this.notFoundText === 'string' && this.notFoundText !== '') {
        return this.notFoundText;
      } else {
        if (!this.notFoundText) {
          return this.defaultNotFoundText[index];
        } else {
          if (this.notFoundText[index]) {
            return this.notFoundText[index];
          } else {
            return this.defaultNotFoundText[index];
          }
        }
      }
    },
    disHandled: function disHandled(level) {
      if (typeof this.disabled === 'number') {
        if (__WEBPACK_IMPORTED_MODULE_0__areaUtil__["a" /* default */].oneOf(this.disabled, __WEBPACK_IMPORTED_MODULE_0__areaUtil__["a" /* default */].levelArr)) {
          return level >= this.disabled;
        }
      } else if (Array.isArray(this.disabled)) {
        var i = 0;
        var isDis = false;
        while (this.disabled[i]) {
          if (this.disabled[i] === level) {
            isDis = true;
            break;
          }
          i++;
        }
        return isDis;
      } else {
        return this.disabled;
      }
    },
    format: function format(labels, selectedData) {
      return this.format2(labels, selectedData, '-');
    },
    format2: function format2(labels, selectedData, symbol) {
      //格式化需要的模板字符串
      var index = labels.length - 1;
      var data = selectedData[index] || false;
      if (data) {
        return labels.join(symbol);
      }
      return labels[index];
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.dataInit();
    this.$nextTick(function () {
      if (Array.isArray(_this3.value)) {
        if (_this3.value.length === 0) {
          _this3.currArea = [];
        } else if (_this3.value.length === 1) {
          _this3.currArea = [_this3.value[0]];
        } else if (_this3.value.length === 2) {
          _this3.currArea = [_this3.value[0], _this3.value[1]];
        }
      }
    });
  }
});

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {};

util.levelArr = [0, 1, 2];

util.oneOf = function (item, arr) {
  return arr.some(function (i) {
    return i === item;
  });
};
util.getIndex = function (list, name) {
  for (var i in list) {
    if (list[i] === name) {
      return i;
    }
  }
};

util.dataType = ['all', 'code', 'name'];

util.checkLevel = function (val) {
  return util.oneOf(val, util.levelArr);
};

/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-cls"},[_c('Row',{attrs:{"gutter":_vm.gutterNum}},[(_vm.show(0))?_c('i-col',{attrs:{"span":_vm.firstSpan}},[_c('Cascader',{attrs:{"clearable":"","transfer":"","data":_vm.areaList,"filterable":_vm.searchable,"change-on-select":_vm.isChange,"render-format":_vm.format,"placeholder":_vm.phHandled(0),"not-found-text":_vm.ndsHandled(0),"disabled":_vm.disabled === undefined ? false : _vm.disHandled(0)},model:{value:(_vm.currArea),callback:function ($$v) {_vm.currArea=$$v},expression:"currArea"}})],1):_vm._e(),_vm._v(" "),(_vm.show(1))?_c('i-col',{attrs:{"span":_vm.span}},[_c('Cascader',{ref:"city",staticStyle:{"width":"100%"},attrs:{"clearable":"","transfer":"","data":_vm.cityList,"change-on-select":_vm.isChange,"filterable":_vm.searchable,"placeholder":_vm.phHandled(1),"not-found-text":_vm.ndsHandled(1),"disabled":_vm.disabled === undefined ? false : _vm.disHandled(1)},model:{value:(_vm.currCit),callback:function ($$v) {_vm.currCit=$$v},expression:"currCit"}})],1):_vm._e(),_vm._v(" "),(_vm.show(2))?_c('i-col',{attrs:{"span":_vm.span}},[_c('Cascader',{ref:"coun",staticStyle:{"width":"100%"},attrs:{"clearable":"","transfer":"","data":_vm.counList,"filterable":_vm.searchable,"change-on-select":_vm.isChange,"placeholder":_vm.phHandled(2),"not-found-text":_vm.ndsHandled(2),"disabled":_vm.disabled === undefined ? false : _vm.disHandled(2)},model:{value:(_vm.currCou),callback:function ($$v) {_vm.currCou=$$v},expression:"currCou"}})],1):_vm._e()],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticSelector_vue__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8f3b882_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StaticSelector_vue__ = __webpack_require__(803);
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8f3b882_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StaticSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StaticSelector',
  props: {
    dispatchName: '',
    params: {
      type: Object
    },
    value: {
      type: [String, Array]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoLoad: {
      type: Boolean,
      default: true
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      realValue: this.value,
      loading: false,
      options: [],
      language: this.$i18n.locale
    };
  },
  mounted: function mounted() {
    this.loadData();
  },

  watch: {
    value: function value(val) {
      var _this = this;

      this.realValue = val;

      //20190528 bug:7348 原因：realValue中包含有options中不存在的value
      if (_typeof(this.realValue) === 'object') {
        // console.log('this.realValue befor',this.realValue)
        if (this.realValue && this.realValue.length > 0 && this.options && this.options.length > 0) {
          var _loop = function _loop(i) {
            var idx = _this.options.findIndex(function (value) {
              return value.value === _this.realValue[i];
            });
            if (idx === -1) {
              _this.realValue.splice(i, 1);
            }
          };

          for (var i in this.realValue) {
            _loop(i);
          }
        }
        // console.log('this.realValue after',this.realValue)
      }
    },
    autoLoad: function autoLoad(val) {
      if (val) {
        this.loadData();
      }
    },

    '$i18n.locale': {
      handler: function handler() {
        // this.loadData()
      },
      deep: true
    }

  },
  methods: {
    changeValue: function changeValue(value) {
      this.$emit('input', value);
      this.$emit('selectChange', value);
    },
    resetValue: function resetValue() {
      if (this.value) {
        this.realValue = this.value;
      } else {
        this.realValue = '';
      }
    },
    loadData: function loadData(remoteUrl) {
      var _this2 = this;

      this.dispatchName = '';
      if (this.params.sellectorUser === 0) {
        // 获取 价格计算目的区域下拉值
        this.dispatchName = 'queryPriceAreaByType';
        if (this.dispatchName && this.autoLoad) {
          this.loading = true;
          var type = 1;
          var list = [];
          if (localStorage.getItem('queryPriceArea')) {
            var queryPriceArea = JSON.parse(localStorage.getItem('queryPriceArea'));
            if (queryPriceArea && queryPriceArea.length > 0) {
              queryPriceArea.forEach(function (item) {
                var displayN = '';
                if (_this2.$i18n.locale === 'zh-CN') {
                  displayN = item.displayNameZh;
                }
                if (_this2.$i18n.locale === 'en-US') {
                  displayN = item.displayNameEn;
                }
                list.push({
                  value: item.value,
                  displayName: displayN
                });
              });
            }
            this.options = list;
            this.loading = false;
          } else {
            this.$store.dispatch(this.dispatchName, { type: type }).then(function () {
              if (!JSON.parse(localStorage.getItem('queryPriceArea'))) {
                list = [];
              } else {
                var _queryPriceArea = JSON.parse(localStorage.getItem('queryPriceArea'));
                if (_queryPriceArea && _queryPriceArea.length > 0) {
                  _queryPriceArea.forEach(function (item) {
                    var displayN = '';
                    if (_this2.$i18n.locale === 'zh-CN') {
                      displayN = item.displayNameZh;
                    }
                    if (_this2.$i18n.locale === 'en-US') {
                      displayN = item.displayNameEn;
                    }
                    list.push({
                      value: item.value,
                      displayName: displayN
                    });
                  });
                }
              }
              _this2.options = list;
              _this2.loading = false;
            }).catch(function (error) {
              _this2.loading = false;
              _this2.options = [];
              console.error(error);
            });
          }
        }
      } else {
        if (this.dispatchName && this.autoLoad) {
          this.loading = true;
          var _list = [];
          this.$store.dispatch(this.dispatchName, { districtCode: districtCode }).then(function (data) {
            if (data && data.success && data.selectorResult && data.selectorResult.length > 0) {
              data.selectorResult.forEach(function (item) {
                if (item && item.value) {
                  _list.push({
                    value: item.value,
                    displayName: item.displayName
                  });
                }
              });
            }
            //添加全部选择条件
            if (_this2.value === 'all') {
              _list.unshift({ displayName: _this2.$t('global.defaultOption'), value: 'all' });
            }
            _this2.options = _list;
            _this2.loading = false;
          }).catch(function (error) {
            _this2.loading = false;
            _this2.options = [];
            console.error(error);
          });
        } else {
          //添加全部选择条件
          if (this.value === 'all') {
            this.options.unshift({ displayName: this.$t('global.defaultOption'), value: 'all' });
          }
        }
      }
    }
  },
  updated: function updated() {
    if (this.params.selectIndex && this.options[this.params.selectIndex]) {
      this.realValue = this.options[this.params.selectIndex]['value'];
    }
    this.params.selectIndex = '';
  }
});

/***/ }),

/***/ 803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"transfer":_vm.transfer,"multiple":_vm.isMultiple,"placeholder":_vm.params.emptyText,"clearable":_vm.clearable,"filterable":_vm.filterable,"disabled":_vm.disabled},on:{"on-change":_vm.changeValue},model:{value:(_vm.realValue),callback:function ($$v) {_vm.realValue=$$v},expression:"realValue"}},_vm._l((_vm.options),function(option){return _c('Option',{key:option.value,attrs:{"value":option.value}},[_vm._v(_vm._s(option.displayName))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElStaticSelector_vue__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd086b74_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ElStaticSelector_vue__ = __webpack_require__(806);
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElStaticSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd086b74_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ElStaticSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElStaticSelector',
  props: {
    dispatchName: '',
    params: {
      type: Object
    },
    value: {
      type: [String, Array]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoLoad: {
      type: Boolean,
      default: true
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      realValue: this.value,
      loading: false,
      options: [],
      language: this.$i18n.locale
    };
  },
  mounted: function mounted() {
    this.loadData();
  },

  watch: {
    value: function value(val) {
      var _this = this;

      this.realValue = val;

      //20190528 bug:7348 原因：realValue中包含有options中不存在的value
      if (_typeof(this.realValue) === 'object') {
        // console.log('this.realValue befor',this.realValue)
        if (this.realValue && this.realValue.length > 0 && this.options && this.options.length > 0) {
          var _loop = function _loop(i) {
            var idx = _this.options.findIndex(function (value) {
              return value.value === _this.realValue[i];
            });
            if (idx === -1) {
              _this.realValue.splice(i, 1);
            }
          };

          for (var i in this.realValue) {
            _loop(i);
          }
        }
        // console.log('this.realValue after',this.realValue)
      }
    },
    autoLoad: function autoLoad(val) {
      if (val) {
        this.loadData();
      }
    },

    '$i18n.locale': {
      handler: function handler() {
        // this.loadData()
      },
      deep: true
    }

  },
  methods: {
    changeValue: function changeValue(value) {
      this.$emit('input', value);
      this.$emit('selectChange', value);
    },
    resetValue: function resetValue() {
      if (this.value) {
        this.realValue = this.value;
      } else {
        this.realValue = '';
      }
    },
    loadData: function loadData(remoteUrl) {
      var _this2 = this;

      this.dispatchName = '';
      if (this.params.sellectorUser === 0) {
        // 获取 价格计算目的区域下拉值
        this.dispatchName = 'queryPriceAreaByType';
        if (this.dispatchName && this.autoLoad) {
          this.loading = true;
          var type = 1;
          var list = [];
          if (localStorage.getItem('queryPriceArea')) {
            var queryPriceArea = JSON.parse(localStorage.getItem('queryPriceArea'));
            if (queryPriceArea && queryPriceArea.length > 0) {
              queryPriceArea.forEach(function (item) {
                var displayN = '';
                if (_this2.$i18n.locale === 'zh-CN') {
                  displayN = item.displayNameZh;
                }
                if (_this2.$i18n.locale === 'en-US') {
                  displayN = item.displayNameEn;
                }
                list.push({
                  value: item.value,
                  displayName: displayN
                });
              });
            }
            this.options = list;
            this.loading = false;
          } else {
            this.$store.dispatch(this.dispatchName, { type: type }).then(function () {
              if (!JSON.parse(localStorage.getItem('queryPriceArea'))) {
                list = [];
              } else {
                var _queryPriceArea = JSON.parse(localStorage.getItem('queryPriceArea'));
                if (_queryPriceArea && _queryPriceArea.length > 0) {
                  _queryPriceArea.forEach(function (item) {
                    var displayN = '';
                    if (_this2.$i18n.locale === 'zh-CN') {
                      displayN = item.displayNameZh;
                    }
                    if (_this2.$i18n.locale === 'en-US') {
                      displayN = item.displayNameEn;
                    }
                    list.push({
                      value: item.value,
                      displayName: displayN
                    });
                  });
                }
              }
              _this2.options = list;
              _this2.loading = false;
            }).catch(function (error) {
              _this2.loading = false;
              _this2.options = [];
              console.error(error);
            });
          }
        }
      } else {
        if (this.dispatchName && this.autoLoad) {
          this.loading = true;
          var _list = [];
          this.$store.dispatch(this.dispatchName, { districtCode: districtCode }).then(function (data) {
            if (data && data.success && data.selectorResult && data.selectorResult.length > 0) {
              data.selectorResult.forEach(function (item) {
                if (item && item.value) {
                  _list.push({
                    value: item.value,
                    displayName: item.displayName
                  });
                }
              });
            }
            //添加全部选择条件
            if (_this2.value === 'all') {
              _list.unshift({ displayName: _this2.$t('global.defaultOption'), value: 'all' });
            }
            _this2.options = _list;
            _this2.loading = false;
          }).catch(function (error) {
            _this2.loading = false;
            _this2.options = [];
            console.error(error);
          });
        } else {
          //添加全部选择条件
          if (this.value === 'all') {
            this.options.unshift({ displayName: this.$t('global.defaultOption'), value: 'all' });
          }
        }
      }
    }
  },
  updated: function updated() {
    if (this.params.selectIndex && this.options[this.params.selectIndex]) {
      this.realValue = this.options[this.params.selectIndex]['value'];
    }
    this.params.selectIndex = '';
  }
});

/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"transfer":_vm.transfer,"multiple":_vm.isMultiple,"placeholder":_vm.params.emptyText,"clearable":_vm.clearable,"filterable":_vm.filterable,"disabled":_vm.disabled},on:{"on-change":_vm.changeValue},model:{value:(_vm.realValue),callback:function ($$v) {_vm.realValue=$$v},expression:"realValue"}},_vm._l((_vm.options.filter(function (item){ return item.value.indexOf('Zone') === -1; })),function(option){return _c('Option',{key:option.value,attrs:{"value":option.value,"label":option.displayName}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container col-jj"},[_c('div',{staticClass:"tracking03_mod"}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"tracking03_pic col-md-12"},[_c('h4',[_vm._v(_vm._s(_vm.$t('tracking.ProductsPricing')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('tracking.SearchPrice')))]),_vm._v(" "),_c('a',{on:{"click":_vm.toSpeedPAK}},[_vm._v(_vm._s(_vm.$t('tracking.SpeedPAK')))]),_vm._v(" "),_c('a',{on:{"click":_vm.toSpeedFreight}},[_vm._v(_vm._s(_vm.$t('tracking.ConsolFreight')))]),_vm._v(" "),_c('a',{on:{"click":_vm.toMc}},[_vm._v(_vm._s(_vm.$t('product.multiChannel.title')))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpeedPAK),expression:"showSpeedPAK"}],staticClass:"col-md-12"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.dlpriceCalcMouseOver),expression:"!dlpriceCalcMouseOver"}],staticClass:"tracking03_btn",on:{"mouseover":_vm.dlmouseOver,"mouseleave":_vm.dlmouseLeave}},[_c('a',{on:{"click":_vm.dlPriceCardDownload}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.dlPriceCard')))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.dlpriceCalcMouseOver),expression:"dlpriceCalcMouseOver"}],staticClass:"tracking03_mouseover_btn",on:{"mouseover":_vm.dlmouseOver,"mouseleave":_vm.dlmouseLeave}},[_c('a',{on:{"click":_vm.dlPriceCardDownload}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.dlPriceCard')))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hkpriceCalcMouseOver),expression:"!hkpriceCalcMouseOver"}],staticClass:"tracking03_btn",on:{"mouseover":_vm.hkmouseOver,"mouseleave":_vm.hkmouseLeave}},[_c('a',{on:{"click":_vm.hkPriceCardDownload}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.hkPriceCard')))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hkpriceCalcMouseOver),expression:"hkpriceCalcMouseOver"}],staticClass:"tracking03_mouseover_btn",on:{"mouseover":_vm.hkmouseOver,"mouseleave":_vm.hkmouseLeave}},[_c('a',{on:{"click":_vm.hkPriceCardDownload}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.hkPriceCard')))])]),_vm._v(" "),_c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.priceCalcMouseOver),expression:"!priceCalcMouseOver"}],staticClass:"tracking03_btn",on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseLeave}},[_c('a',{attrs:{"icon":"ios-calculator"},on:{"click":_vm.spkPriceCalculator}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.spkPriceCalculator')))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.priceCalcMouseOver),expression:"priceCalcMouseOver"}],staticClass:"tracking03_mouseover_btn",on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseLeave}},[_c('a',{attrs:{"icon":"ios-calculator"},on:{"click":_vm.spkPriceCalculator}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.spkPriceCalculator')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpeedFreight),expression:"showSpeedFreight"}],staticClass:"tracking03_btn col-md-12"},[_c('a',{on:{"click":_vm.spfPriceCardDownload}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.spfPriceCard')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpeedFreightAsia),expression:"showSpeedFreightAsia"}],staticClass:"tracking03_btn col-md-12"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMc),expression:"showMc"}],staticClass:"tracking03_btn col-md-12"},[_c('a',{on:{"click":_vm.mcPriceCardDownload}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.dlPriceCard')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.spkPriceCalculatorShow && _vm.showSpeedPAK),expression:"spkPriceCalculatorShow && showSpeedPAK"}],staticStyle:{"background":"#eee","padding":"10px 20px 20px 20px"}},[_c('Row',{staticStyle:{"padding-bottom":"10px"}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.gridData.title')))])]),_vm._v(" "),_c('Row',[_c('Card',{attrs:{"shadow":""}},[_c('div',{staticClass:"app-container"},[_c('div',{staticClass:"filter-container"},[_c('Form',{ref:"validateRule",attrs:{"label-width":95,"rules":_vm.validateRules2}},[_c('Row',[_c('i-col',{attrs:{"xs":12,"sm":12,"lg":6}},[_c('Form-item',{attrs:{"label":_vm.$t('tracking.tracking03.spkPriceCalculate.conditions.departure'),"prop":"departure2"}},[_c('Select',{staticStyle:{"width":"100%"},model:{value:(_vm.calculate.departure),callback:function ($$v) {_vm.$set(_vm.calculate, "departure", $$v)},expression:"calculate.departure"}},_vm._l((_vm.departureList),function(item){return _c('Option',{key:item.value,attrs:{"label":item.key,"value":item.value}})}))],1)],1),_vm._v(" "),_c('i-col',{attrs:{"xs":12,"sm":12,"lg":6}},[_c('Form-item',{attrs:{"label":_vm.$t('tracking.tracking03.spkPriceCalculate.conditions.destination'),"prop":"destination"}},[_c('el-static-selector',{ref:"arrivalsPriceAreaCodeSelector2",staticClass:"trueTrackList",staticStyle:{"width":"100%"},attrs:{"params":_vm.arrivalsPriceAreaCodeSelector,"value":_vm.calculate.destination,"autoLoad":true,"filterable":true},model:{value:(_vm.calculate.destination),callback:function ($$v) {_vm.$set(_vm.calculate, "destination", $$v)},expression:"calculate.destination"}})],1)],1)],1),_vm._v(" "),_c('Row',[_c('i-col',{attrs:{"xs":12,"sm":12,"lg":6}},[_c('div',[_c('Form-item',{attrs:{"label":_vm.$t('tracking.tracking03.spkPriceCalculate.conditions.orderTime')}},[_c('DatePicker',{attrs:{"type":"datetime","options":_vm.orderTimeOptions,"clearable":false},model:{value:(_vm.calculate.orderTime),callback:function ($$v) {_vm.$set(_vm.calculate, "orderTime", $$v)},expression:"calculate.orderTime"}})],1)],1)]),_vm._v(" "),_c('i-col',{attrs:{"xs":12,"sm":12,"lg":6}},[_c('div',[_c('Form-item',{attrs:{"label":_vm.$t('tracking.tracking03.spkPriceCalculate.conditions.weight'),"prop":"weight"}},[_c('Input',{attrs:{"placeholder":_vm.$t('tracking.tracking03.spkPriceCalculate.prompt.weight')},model:{value:(_vm.calculate.weight),callback:function ($$v) {_vm.$set(_vm.calculate, "weight", $$v)},expression:"calculate.weight"}}),_vm._v(" "),_c('span',{attrs:{"slot":"append"},slot:"append"},[_vm._v("g")])],1)],1)])],1),_vm._v(" "),_c('Row',[_c('i-col',{attrs:{"xs":12,"sm":12,"lg":6}},[_c('div',[_c('Form-item',{attrs:{"label":_vm.$t('tracking.tracking03.spkPriceCalculate.conditions.length'),"prop":"length"}},[_c('Input',{model:{value:(_vm.calculate.length),callback:function ($$v) {_vm.$set(_vm.calculate, "length", $$v)},expression:"calculate.length"}}),_vm._v(" "),_c('span',{attrs:{"slot":"append"},slot:"append"},[_vm._v("cm")])],1)],1)]),_vm._v(" "),_c('i-col',{attrs:{"xs":12,"sm":12,"lg":6}},[_c('div',[_c('Form-item',{attrs:{"label":_vm.$t('tracking.tracking03.spkPriceCalculate.conditions.width'),"prop":"width"}},[_c('Input',{model:{value:(_vm.calculate.width),callback:function ($$v) {_vm.$set(_vm.calculate, "width", $$v)},expression:"calculate.width"}}),_vm._v(" "),_c('span',{attrs:{"slot":"append"},slot:"append"},[_vm._v("cm")])],1)],1)]),_vm._v(" "),_c('i-col',{attrs:{"xs":12,"sm":12,"lg":6}},[_c('div',[_c('Form-item',{attrs:{"label":_vm.$t('tracking.tracking03.spkPriceCalculate.conditions.height'),"prop":"height"}},[_c('Input',{model:{value:(_vm.calculate.height),callback:function ($$v) {_vm.$set(_vm.calculate, "height", $$v)},expression:"calculate.height"}}),_vm._v(" "),_c('span',{attrs:{"slot":"append"},slot:"append"},[_vm._v("cm")])],1)],1)])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"panel-container"},[_c('Row',[_c('i-col',{attrs:{"offset":"14","span":"3"}},[_c('Button',{attrs:{"type":"primary","icon":"ios-calculator","disabled":!this.calculateControl,"loading":_vm.requestLoading},on:{"click":_vm.clickCalculate}},[(!_vm.requestLoading)?_c('span',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.calBtnText')))]):_c('span',[_vm._v(_vm._s(_vm.$t('global.loading')))])])],1),_vm._v(" "),_c('i-col',{attrs:{"span":"2"}},[_c('Button',{attrs:{"type":"primary","icon":"ios-calculator"},on:{"click":_vm.clickReset}},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.spkPriceCalculate.calReset')))])],1)],1)],1),_vm._v(" "),_c('div',[_c('Row',[_c('div',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.remin')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.tip1')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.tip2Prefix'))),_c('a',{attrs:{"target":"_blank"},on:{"click":_vm.clickScroll}},[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.tip2Middle')))]),_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.tip2Suffix')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Prefix'))),_c('a',{attrs:{"href":"https://www.orangeconnex.com/trackingPackage","target":"_blank"}},[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Middle')))]),_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Suffix')))])])],1)])])],1),_vm._v(" "),_c('Row',{staticStyle:{"background":"#eee","padding":"10px"}}),_vm._v(" "),_c('Row',[_c('Card',{attrs:{"shadow":""}},[_c('div',{staticClass:"app-container"},[_c('div',{staticClass:"panel-container"},[_c('Row',{attrs:{"id":"grid"}},[_c('Row',[_c('i-col',[_c('div',{staticStyle:{"margin-top":"6px"}},[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.gridData.result')))])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.datagridShow),expression:"!datagridShow"}]},[_c('Row',[_c('hr')]),_vm._v(" "),_c('Row',{directives:[{name:"show",rawName:"v-show",value:(!_vm.calcuNullShow),expression:"!calcuNullShow"}],staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.gridData.noResult')))])]),_vm._v(" "),_c('Row',{directives:[{name:"show",rawName:"v-show",value:(_vm.calcuNullShow),expression:"calcuNullShow"}],staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.alert.calcuNull')))])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.datagridShow),expression:"datagridShow"}]},[_c('Row',{staticStyle:{"padding-bottom":"20px"}},[_c('hr')]),_vm._v(" "),_c('Row',[_c('i-col',{staticClass:"priceTr",attrs:{"span":"7"}},[_c('div',{staticClass:"priceEsHeader2222"},[_c('b',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.conditions.productOuter')))])])]),_vm._v(" "),_c('i-col',{staticClass:"priceTr",attrs:{"span":"3"}},[_c('div',{staticClass:"priceEsHeader2222"},[_c('b',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.conditions.calWeight')))])])]),_vm._v(" "),_c('i-col',{staticClass:"priceTr",attrs:{"span":"3"}},[_c('div',{staticClass:"priceEsHeader2222"},[_c('span',[_c('b',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.conditions.chargeType')))])]),_vm._v(" "),_c('span',[_c('Tooltip',{attrs:{"placement":"top","transfer":""}},[_c('span',[_vm._v("ⓘ")]),_vm._v(" "),_c('div',{staticStyle:{"white-space":"normal","word-break":"normal","width":"240px"},attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip5')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip1')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip2')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip3')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip6')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip7')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip8')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip9')))])])])],1)])]),_vm._v(" "),_c('i-col',{staticClass:"priceTr",attrs:{"span":"3"}},[_c('div',{staticClass:"priceEsHeader2222"},[_c('b',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.conditions.charged')))])])]),_vm._v(" "),_c('i-col',{staticClass:"priceTr",attrs:{"span":"4"}},[_c('div',{staticClass:"priceEsHeader2222"},[_c('b',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.gridData.total')))])])]),_vm._v(" "),_c('i-col',{staticClass:"priceTr",attrs:{"span":"2"}},[_c('div',{staticClass:"priceEsHeader2222"},[_c('b',[_vm._v(_vm._s(this.$t('tracking.tracking03.spkPriceCalculate.gridData.remark')))])])])],1),_vm._v(" "),_vm._l((this.gridData),function(item,index){return _c('Row',{key:index},[_c('i-col',{staticClass:"priceTd",attrs:{"span":"7"}},[(_vm.language222 === 'en-US')?_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(item.productOuterNameEn))]):_vm._e(),_vm._v(" "),(_vm.language222 === 'zh-CN')?_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(item.productOuter))]):_vm._e()]),_vm._v(" "),_c('i-col',{staticClass:"priceTd",attrs:{"span":"3"}},[_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(item.weight)+" g")])]),_vm._v(" "),_c('i-col',{staticClass:"priceTd",attrs:{"span":"3"}},[_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(item.chargeType))])]),_vm._v(" "),_c('i-col',{staticClass:"priceTd",attrs:{"span":"3"}},[(item.batteryType === 0)?_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.list.yes')))]):_vm._e(),_vm._v(" "),(item.batteryType === 1)?_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(_vm.$t('tracking.tracking03.list.no')))]):_vm._e()]),_vm._v(" "),_c('i-col',{staticClass:"priceTd",attrs:{"span":"4"}},[_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(item.totalCost)+" "+_vm._s(item.currency))])]),_vm._v(" "),_c('i-col',{staticClass:"priceTd",attrs:{"span":"2"}},[(_vm.language222 === 'en-US')?_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(item.flowRemarkEn))]):_vm._e(),_vm._v(" "),(_vm.language222 === 'zh-CN')?_c('div',{staticClass:"priceEsHeader2222"},[_vm._v(_vm._s(item.flowRemark))]):_vm._e()])],1)}),_vm._v(" "),_c('Row',{staticStyle:{"padding-top":"10px"}})],2)],1)],1)])])],1)],1),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{attrs:{"id":"clickShow"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpeedPAK && (_vm.showSpeedPAKcn || _vm.spkPriceCalculatorShow)),expression:"showSpeedPAK && (showSpeedPAKcn || spkPriceCalculatorShow)"}],staticStyle:{"width":"100%"},attrs:{"src":_vm.tracking03}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpeedPAK && (_vm.showSpeedPAKhk || _vm.spkPriceCalculatorShow)),expression:"showSpeedPAK && (showSpeedPAKhk || spkPriceCalculatorShow)"}],staticStyle:{"width":"100%"},attrs:{"src":_vm.hkPriceImg}})]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpeedFreight),expression:"showSpeedFreight"}],staticStyle:{"width":"100%"},attrs:{"src":_vm.spfImg}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMc),expression:"showMc"}],staticStyle:{"width":"100%"},attrs:{"src":_vm.mcImg}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// resource/js/3.1fd14fad87a28c5bd1db.js